import { c as _c } from "react/compiler-runtime";
import { Toast as ToastComponent } from '@shared/components/Toast';
import { useLocalStorage } from '@shared/hooks/useLocalStorage';
import { createContext, startTransition, useContext, useEffect, useState } from 'react';
export const ToastType = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};
export const ToastContext = createContext(undefined);
export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
}
export function ToastProvider(t0) {
  const $ = _c(27);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    setValue: setQueuedToasts,
    getCurrentValue: getQueuedToasts,
    clearCurrentValue: clearToasts
  } = useLocalStorage("queuedToasts", t1);
  const [activeToast, setActiveToast] = useState();
  let t2;
  if ($[1] !== getQueuedToasts || $[2] !== setQueuedToasts) {
    t2 = args => {
      const {
        message,
        type: t3,
        duration: t4
      } = args;
      const type = t3 === undefined ? ToastType.info : t3;
      const duration = t4 === undefined ? 3000 : t4;
      const id = Date.now();
      const newToast = {
        id,
        message,
        type,
        duration
      };
      setQueuedToasts([...getQueuedToasts(), newToast]);
    };
    $[1] = getQueuedToasts;
    $[2] = setQueuedToasts;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const queueToast = t2;
  let t3;
  if ($[4] !== getQueuedToasts || $[5] !== setQueuedToasts) {
    t3 = args_0 => {
      const {
        message: message_0,
        type: t4,
        duration: t5
      } = args_0;
      const type_0 = t4 === undefined ? ToastType.info : t4;
      const duration_0 = t5 === undefined ? 3000 : t5;
      const id_0 = Date.now();
      const newToast_0 = {
        id: id_0,
        message: message_0,
        type: type_0,
        duration: duration_0
      };
      const toasts = getQueuedToasts();
      toasts.shift();
      setQueuedToasts([newToast_0, ...toasts]);
      setActiveToast(newToast_0);
    };
    $[4] = getQueuedToasts;
    $[5] = setQueuedToasts;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const pushToast = t3;
  let t4;
  if ($[7] !== getQueuedToasts || $[8] !== setQueuedToasts) {
    t4 = () => {
      const remainingToasts = getQueuedToasts();
      remainingToasts.shift();
      setActiveToast(undefined);
      setQueuedToasts(remainingToasts);
    };
    $[7] = getQueuedToasts;
    $[8] = setQueuedToasts;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const dequeueFirstToast = t4;
  let t5;
  let t6;
  if ($[10] !== activeToast || $[11] !== getQueuedToasts) {
    t5 = () => {
      const queuedToasts = getQueuedToasts();
      if (queuedToasts && queuedToasts.length && !activeToast) {
        startTransition(() => {
          setActiveToast(queuedToasts.at(0));
        });
      }
    };
    t6 = [activeToast, getQueuedToasts];
    $[10] = activeToast;
    $[11] = getQueuedToasts;
    $[12] = t5;
    $[13] = t6;
  } else {
    t5 = $[12];
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  if ($[14] !== clearToasts || $[15] !== pushToast || $[16] !== queueToast) {
    t7 = {
      queueToast,
      pushToast,
      clearToasts
    };
    $[14] = clearToasts;
    $[15] = pushToast;
    $[16] = queueToast;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== activeToast || $[19] !== dequeueFirstToast) {
    t8 = !!activeToast && <ToastComponent duration={activeToast.duration} onClose={dequeueFirstToast} message={activeToast.message} type={activeToast.type} key={activeToast.id} />;
    $[18] = activeToast;
    $[19] = dequeueFirstToast;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== children || $[22] !== t8) {
    t9 = <>{children}{t8}</>;
    $[21] = children;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t7 || $[25] !== t9) {
    t10 = <ToastContext.Provider value={t7}>{t9}</ToastContext.Provider>;
    $[24] = t7;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}